@if (item) {
  <a
    appActiveRoute
    appUnsavedFormCheck
    class="nav-link nav-link-dropdown d-flex justify-content-start align-items-center nav-link-route p-0"
    [href]="item.route ? item.route : '#'"
    [ngClass]="{ 'dropdown-hover__trigger': item.subMenus }"
    (click)="launchLoadingIndicator($event, item.route ? item.route : '#')"
    (unsavedForm)="handleUnsavedFormState($event)"
  >
    <span class="nav-item__icon-container position-relative">
      @if (item.jipIcon && item.isSharedIcon) {
        <app-shared-icon [name]="item.jipIcon"></app-shared-icon>
      }
      @if (item.ngIcon) {
        <ng-icon
          class="nav__item-icon"
          [name]="item.ngIcon"
          size="1.5rem"
        ></ng-icon>
      }
      @if (item.jipIcon && !item.isSharedIcon) {
        <app-internal-icon
          [name]="item.jipIcon"
          [height]="24"
        >
        </app-internal-icon>
      }
      @if (!!count) {
        <span class="news__badge"></span>
      }
    </span>
    <span
      [style.min-width.px]="item.minWidth || 'unset'"
      class="py-1 font-size-sm ms-3"
    >
      {{ item.name | translate }}
    </span>
  </a>
}
